module.exports = __webpack_public_path__ + "03_long_brown.5827bef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_long_brown.png
// module id = mtz0
// module chunks = 0